// Central source of truth for brands, models, cities, services, FAQs
// Pricing is at SERVICE level (starting from). Models are listed comprehensively per brand.

export const BUSINESS = {
  whatsapp: "918796299266", // country code + number, no + or spaces
  name: "DoorstepScreens",
};

export const CITIES = [
  { slug: "delhi", name: "Delhi", region: "NCR", tagline: "All areas of Delhi", lat: 28.7041, lng: 77.1025 },
  { slug: "noida", name: "Noida", region: "NCR", tagline: "Sector 1 to 168, Greater Noida", lat: 28.5355, lng: 77.3910 },
  { slug: "gurgaon", name: "Gurgaon", region: "NCR", tagline: "Golf Course, Cyber City, Sohna Road", lat: 28.4595, lng: 77.0266 },
  { slug: "ghaziabad", name: "Ghaziabad", region: "NCR", tagline: "Indirapuram, Vaishali, Raj Nagar", lat: 28.6692, lng: 77.4538 },
  { slug: "faridabad", name: "Faridabad", region: "NCR", tagline: "NIT, Old Faridabad, Greater Faridabad", lat: 28.4089, lng: 77.3178 },
  { slug: "hyderabad", name: "Hyderabad", region: "South", tagline: "HITEC City, Gachibowli, Banjara Hills", lat: 17.3850, lng: 78.4867 },
  { slug: "bangalore", name: "Bangalore", region: "South", tagline: "Koramangala, Indiranagar, Whitefield", lat: 12.9716, lng: 77.5946 },
  { slug: "pune", name: "Pune", region: "West", tagline: "Koregaon Park, Viman Nagar, Baner", lat: 18.5204, lng: 73.8567 },
  { slug: "mumbai", name: "Mumbai", region: "West", tagline: "Andheri, Bandra, Powai, Thane", lat: 19.0760, lng: 72.8777 },
  { slug: "lucknow", name: "Lucknow", region: "North", tagline: "Gomti Nagar, Hazratganj, Alambagh", lat: 26.8467, lng: 80.9462 },
];

export const CITY_NAMES = CITIES.map((c) => c.name);

export const SERVICES = [
  {
    id: "screen",
    slug: "screen-replacement",
    title: "Screen Replacement",
    desc: "Cracked, blackout, dead pixels, touch issues — we replace with premium OLED/LCD.",
    icon: "Smartphone",
    from: 1499,
  },
  {
    id: "battery",
    slug: "battery-replacement",
    title: "Battery Replacement",
    desc: "Draining fast? Swelling? Get a fresh battery with 365-day warranty.",
    icon: "BatteryCharging",
    from: 999,
  },
  {
    id: "charging",
    slug: "charging-port-replacement",
    title: "Charging Port Replacement",
    desc: "Loose pin, no charge, slow charge — new port fitted at your doorstep.",
    icon: "Zap",
    from: 799,
  },
  {
    id: "speaker",
    slug: "speaker-replacement",
    title: "Speaker Replacement",
    desc: "No sound, muffled audio, call speaker issues — fixed while you wait.",
    icon: "Volume2",
    from: 699,
  },
];

export const BRANDS = [
  { id: "apple", slug: "apple", name: "Apple", tagline: "iPhone & iPad", logo: "/brands/apple.webp" },
  { id: "samsung", slug: "samsung", name: "Samsung", tagline: "Galaxy S / A / M / Fold", logo: "/brands/samsung.webp" },
  { id: "oneplus", slug: "oneplus", name: "OnePlus", tagline: "Nord / R / Pro", logo: "/brands/oneplus.webp" },
  { id: "xiaomi", slug: "xiaomi", name: "Xiaomi", tagline: "Redmi / Mi / Poco", logo: "/brands/xiaomi.webp" },
  { id: "pixel", slug: "google-pixel", name: "Google Pixel", tagline: "Pixel 6/7/8/9", logo: "/brands/pixel.webp" },
  { id: "nothing", slug: "nothing", name: "Nothing", tagline: "Phone 1/2/2a/3", logo: "/brands/nothing.webp" },
  { id: "realme", slug: "realme", name: "Realme", tagline: "Narzo / Pro / GT", logo: "/brands/realme.webp" },
  { id: "motorola", slug: "motorola", name: "Motorola", tagline: "Edge / G / Razr", logo: "/brands/motorola.webp" },
];

// Comprehensive model list per brand (Buzzmeeh-style)
export const MODELS_BY_BRAND = {
  apple: [
    "iPhone 16 Pro Max", "iPhone 16 Pro", "iPhone 16 Plus", "iPhone 16",
    "iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15",
    "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus", "iPhone 14",
    "iPhone SE (3rd Gen)", "iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13", "iPhone 13 mini",
    "iPhone 12 Pro Max", "iPhone 12 Pro", "iPhone 12", "iPhone 12 mini",
    "iPhone SE (2nd Gen)", "iPhone 11 Pro Max", "iPhone 11 Pro", "iPhone 11",
    "iPhone XS Max", "iPhone XS", "iPhone XR", "iPhone X",
    "iPhone 8 Plus", "iPhone 8", "iPhone 7 Plus", "iPhone 7",
    "iPad Pro 12.9 (M4)", "iPad Pro 11 (M4)", "iPad Air (M2)", "iPad 10th Gen",
    "iPad 9th Gen", "iPad mini 6", "iPad Pro 12.9 (2021)", "iPad Air 4",
  ],
  samsung: [
    "Galaxy S26 Ultra", "Galaxy S25 Ultra", "Galaxy S25+", "Galaxy S25",
    "Galaxy S24 Ultra", "Galaxy S24+", "Galaxy S24", "Galaxy S24 FE",
    "Galaxy S23 Ultra", "Galaxy S23+", "Galaxy S23", "Galaxy S23 FE",
    "Galaxy S22 Ultra", "Galaxy S22+", "Galaxy S22", "Galaxy S21 FE",
    "Galaxy S21 Ultra", "Galaxy S21+", "Galaxy S21", "Galaxy S20 FE",
    "Galaxy Z Fold 6", "Galaxy Z Fold 5", "Galaxy Z Fold 4", "Galaxy Z Fold 3",
    "Galaxy Z Flip 6", "Galaxy Z Flip 5", "Galaxy Z Flip 4", "Galaxy Z Flip 3",
    "Galaxy Note 20 Ultra", "Galaxy Note 20", "Galaxy Note 10 Lite", "Galaxy Note 10+",
    "Galaxy A55", "Galaxy A35", "Galaxy A25", "Galaxy A15", "Galaxy A54", "Galaxy A34", "Galaxy A24",
    "Galaxy M55", "Galaxy M54", "Galaxy M53", "Galaxy M34", "Galaxy M33", "Galaxy M32", "Galaxy M14",
    "Galaxy F55", "Galaxy F54", "Galaxy F14",
  ],
  oneplus: [
    "OnePlus 13", "OnePlus 13R", "OnePlus 12", "OnePlus 12R",
    "OnePlus 11", "OnePlus 11R", "OnePlus 10 Pro", "OnePlus 10T", "OnePlus 10R",
    "OnePlus 9 Pro", "OnePlus 9", "OnePlus 9R", "OnePlus 9RT",
    "OnePlus 8 Pro", "OnePlus 8", "OnePlus 8T",
    "OnePlus Nord 4", "OnePlus Nord 3", "OnePlus Nord CE 4", "OnePlus Nord CE 3",
    "OnePlus Nord CE 3 Lite", "OnePlus Nord CE 2", "OnePlus Nord CE 2 Lite",
    "OnePlus Nord 2T", "OnePlus Nord 2", "OnePlus Nord N300",
    "OnePlus Open",
  ],
  xiaomi: [
    "Xiaomi 14 Ultra", "Xiaomi 14", "Xiaomi 13 Pro", "Xiaomi 13",
    "Xiaomi 12 Pro", "Xiaomi 12", "Xiaomi 11i Hypercharge", "Xiaomi 11T Pro",
    "Redmi Note 14 Pro+", "Redmi Note 14 Pro", "Redmi Note 14",
    "Redmi Note 13 Pro+", "Redmi Note 13 Pro", "Redmi Note 13",
    "Redmi Note 12 Pro+", "Redmi Note 12 Pro", "Redmi Note 12",
    "Redmi Note 11 Pro+", "Redmi Note 11 Pro", "Redmi Note 11",
    "Redmi K70", "Redmi K60", "Redmi K50i", "Redmi K20 Pro",
    "Redmi 13C", "Redmi 12", "Redmi 11 Prime", "Redmi 10 Prime",
    "Poco F6 Pro", "Poco F6", "Poco F5", "Poco F4", "Poco F3",
    "Poco X6 Pro", "Poco X6", "Poco X5 Pro", "Poco M6 Pro", "Poco M5",
  ],
  pixel: [
    "Pixel 9 Pro XL", "Pixel 9 Pro", "Pixel 9", "Pixel 9 Pro Fold",
    "Pixel 8 Pro", "Pixel 8", "Pixel 8a",
    "Pixel 7 Pro", "Pixel 7", "Pixel 7a", "Pixel Fold",
    "Pixel 6 Pro", "Pixel 6", "Pixel 6a",
    "Pixel 5", "Pixel 5a", "Pixel 4a (5G)", "Pixel 4a",
    "Pixel 4 XL", "Pixel 4", "Pixel 3a XL", "Pixel 3a",
    "Pixel 3 XL", "Pixel 3", "Pixel 2 XL", "Pixel 2",
  ],
  nothing: [
    "Nothing Phone (3)", "Nothing Phone (2)", "Nothing Phone (2a)",
    "Nothing Phone (2a) Plus", "Nothing Phone (1)", "Nothing CMF Phone 1",
  ],
  realme: [
    "Realme GT 6", "Realme GT 5 Pro", "Realme GT Neo 5", "Realme GT 3",
    "Realme 13 Pro+", "Realme 13 Pro", "Realme 12 Pro+", "Realme 12 Pro", "Realme 12",
    "Realme 11 Pro+", "Realme 11 Pro", "Realme 11",
    "Realme 10 Pro+", "Realme 10 Pro", "Realme 10",
    "Realme Narzo 70 Pro", "Realme Narzo 70", "Realme Narzo 60 Pro", "Realme Narzo 60",
    "Realme Narzo 50 Pro", "Realme Narzo 50", "Realme Narzo 30",
    "Realme C67", "Realme C55", "Realme C53", "Realme C51",
  ],
  motorola: [
    "Motorola Edge 50 Ultra", "Motorola Edge 50 Pro", "Motorola Edge 50 Fusion",
    "Motorola Edge 40 Pro", "Motorola Edge 40", "Motorola Edge 40 Neo", "Motorola Edge 30 Fusion",
    "Motorola Edge 30 Ultra", "Motorola Edge 30 Pro", "Motorola Edge 30",
    "Motorola Razr 50 Ultra", "Motorola Razr 50", "Motorola Razr 40 Ultra", "Motorola Razr 40",
    "Moto G85", "Moto G84", "Moto G73", "Moto G62", "Moto G54", "Moto G53", "Moto G34",
    "Moto G Power", "Moto G Stylus", "Moto G Play",
  ],
};

// Top popular models for SEO landing pages (manageable subset)
export const TOP_SEO_MODELS = [
  { brand: "apple", model: "iPhone 16 Pro Max" },
  { brand: "apple", model: "iPhone 15 Pro" },
  { brand: "apple", model: "iPhone 14" },
  { brand: "apple", model: "iPhone 13" },
  { brand: "apple", model: "iPhone 12" },
  { brand: "apple", model: "iPhone 11" },
  { brand: "samsung", model: "Galaxy S24 Ultra" },
  { brand: "samsung", model: "Galaxy S23" },
  { brand: "samsung", model: "Galaxy Z Fold 6" },
  { brand: "samsung", model: "Galaxy Z Flip 6" },
  { brand: "oneplus", model: "OnePlus 12" },
  { brand: "oneplus", model: "OnePlus 11" },
  { brand: "oneplus", model: "OnePlus Nord CE 4" },
  { brand: "pixel", model: "Pixel 9 Pro" },
  { brand: "pixel", model: "Pixel 8a" },
  { brand: "xiaomi", model: "Redmi Note 14 Pro" },
  { brand: "xiaomi", model: "Poco F6" },
  { brand: "nothing", model: "Nothing Phone (2a)" },
  { brand: "realme", model: "Realme GT 6" },
  { brand: "motorola", model: "Motorola Edge 50 Pro" },
];

export const ISSUES = [
  "Screen Cracked / Broken",
  "Screen Black / No Display",
  "Touch Not Working",
  "Battery Draining Fast",
  "Phone Not Charging",
  "Charging Port Loose",
  "Speaker Not Working",
  "Microphone Issue",
  "Water Damage",
  "Other / Not Sure",
];

export const HOW_IT_WORKS = [
  { step: "01", title: "Book Online", desc: "Fill the 30-second form with your model and issue." },
  { step: "02", title: "We Visit You", desc: "Our expert technician reaches you in 90 mins*." },
  { step: "03", title: "Repair at Doorstep", desc: "Transparent diagnosis, genuine parts, repair in front of you." },
  { step: "04", title: "365 Days Warranty", desc: "Pay only after repair. 365 days warranty on parts & service." },
];

export const TRUST_BADGES = [
  { label: "365 Days Warranty", sub: "On parts & service" },
  { label: "Genuine Parts", sub: "OEM-grade quality" },
  { label: "Doorstep Repair", sub: "We come to you" },
  { label: "Same-Day Service", sub: "90-minute response" },
  { label: "Certified Experts", sub: "5+ years exp." },
  { label: "Pay After Repair", sub: "100% transparent" },
];

export const TESTIMONIALS = [
  { name: "Rohan Mehta", city: "Gurgaon", phone: "iPhone 14 Pro", text: "Technician came in 1 hour. Replaced screen right in front of me. 365-day warranty card handed over. Impressive.", rating: 5 },
  { name: "Priya Sharma", city: "Bangalore", phone: "Samsung S23", text: "Most repair shops wanted my phone for 2 days. Doorstepscreens fixed it in 45 mins at my office. Genuine OLED.", rating: 5 },
  { name: "Arjun Kapoor", city: "Mumbai", phone: "OnePlus 11", text: "Transparent pricing, no hidden fees. The technician explained each step. Battery life back to day-one performance.", rating: 5 },
  { name: "Sneha Patel", city: "Pune", phone: "Pixel 8", text: "Pixel parts are rare in India — they had it. Fixed in 30 mins. Charged exactly what was quoted online.", rating: 5 },
  { name: "Vikas Gupta", city: "Delhi", phone: "iPhone 15", text: "Cracked screen on a Sunday. Booked at 11 AM, repaired by 1 PM. Warranty is real — I had a small issue, they came again free.", rating: 5 },
  { name: "Ananya Singh", city: "Hyderabad", phone: "Redmi Note 13", text: "Affordable, quick and professional. Only place I trust with my phone now.", rating: 5 },
];

export const FAQS = [
  { q: "Do you really repair at my doorstep?", a: "Yes. Our certified technicians travel to your home, office or any preferred location across Delhi NCR, Hyderabad, Bangalore, Pune, Mumbai, and Lucknow. Repairs like screen, battery, charging port and speaker replacement are done in front of you in 30–90 minutes." },
  { q: "How long does a typical doorstep mobile repair take?", a: "A typical turnaround is under 30 to 90 minutes. Our expert technician visits your home or office and completes the repair right in front of you." },
  { q: "Are the parts genuine?", a: "We use OEM-grade original parts for all brands including Apple, Samsung, OnePlus, Xiaomi, Google Pixel, Nothing, Realme and Motorola. Every part is tested before installation and covered by our 365-day warranty." },
  { q: "How much does iPhone screen replacement cost?", a: "iPhone screen replacement pricing depends on the model. Final quote is always confirmed before repair begins — no hidden fees. Call us or book online for an instant quote." },
  { q: "Do you replace Samsung folding phone screens?", a: "Yes. We replace Samsung Galaxy Fold 5, Fold 6, Flip 5 and Flip 6 screens. Folding screens are specialist work — covered with our 365 days warranty." },
  { q: "What kind of warranty do you provide on repairs?", a: "We provide a 365-day warranty on both parts and services. This includes free re-repair at your doorstep if any technical issues arise within one full year." },
  { q: "Which cities do you serve?", a: "Delhi, Noida, Gurgaon, Ghaziabad, Faridabad, Hyderabad, Bangalore, Pune, Mumbai and Lucknow. We're expanding — if your pincode is not covered, call us and we'll try to arrange." },
  { q: "When do I have to pay for my mobile repair service?", a: "We operate with 100% transparency. You only pay after the repair is completed, thoroughly checked, and tested right in front of you." },
];

export const SEO_KEYWORDS = [
  "doorstep mobile repair", "iphone screen replacement", "iphone battery replacement",
  "iphone back glass replacement", "samsung screen replacement", "oneplus screen replacement",
  "google pixel screen replacement", "xiaomi screen replacement", "motorola screen replacement",
  "realme screen replacement", "nothing phone screen replacement", "mobile display repair",
  "mobile repair shop near me", "best mobile repair shop near me", "doorstep mobile repairing",
  "iphone 15 screen replacement", "iphone 16 pro max screen replacement", "iphone 14 screen replacement",
  "iphone 13 pro screen replacement", "iphone 12 display replacement", "iphone 11 lcd display",
  "samsung s24 ultra screen replacement", "samsung s23 screen replacement",
  "oneplus 12 screen replacement", "oneplus 11 screen replacement",
  "pixel 9 pro screen replacement", "pixel 8a display replacement",
  "samsung fold 6 screen replacement", "flip 6 screen replacement",
  "iphone screen repair gurgaon", "iphone screen repair delhi", "iphone screen repair bangalore",
  "mobile repair at home", "doorstep screen replacement", "screen replacement near me",
];

// Helper: find brand by slug
export const getBrandBySlug = (slug) => BRANDS.find((b) => b.slug === slug);
export const getCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
export const slugifyModel = (model) => model.toLowerCase().replace(/[()]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
